const LOGO_URL = "https://storage.readdy-site.link/project_files/91d33e52-58d2-42bb-9fc0-529365f1aafc/371b55df-6645-4987-b0c7-b039d0a07bb2_taurus.jpg?v=7463f65f750d1c25236e63c68a6b56d1";

export default function Footer() {
  return (
    <footer className="w-full py-16 px-6 lg:px-12 bg-white border-t border-stone-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-stone-100">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src={LOGO_URL}
                alt="Taurus Contracting"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-stone-500 text-xs leading-relaxed mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Commercial general contracting, design/build, and project management delivered with precision across Ontario.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/tauruscontracting.ca/" },
                { icon: "ri-facebook-line", href: "https://www.facebook.com/tauruscontracting.ca/" },
                { icon: "ri-linkedin-line", href: "https://ca.linkedin.com/company/taurus-contracting-limited-a-division-of-tcl-inc/" },
              ].map((s) => (
                <a
                  key={s.href}
                  href={s.href}
                  rel="nofollow"
                  target="_blank"
                  className="w-8 h-8 flex items-center justify-center rounded-sm border border-stone-200 text-stone-400 hover:border-stone-400 hover:text-stone-700 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="text-stone-400 text-xs uppercase tracking-[0.2em] font-semibold mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Services</p>
            <ul className="space-y-3">
              {["General Contracting", "Design/Build Contracting", "Commercial Leasehold Improvements", "Pre Construction", "Project Management"].map((s) => (
                <li key={s}>
                  <span className="text-stone-500 text-xs hover:text-stone-800 transition-colors cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>{s}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <p className="text-stone-400 text-xs uppercase tracking-[0.2em] font-semibold mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Service Areas</p>
            <ul className="space-y-3">
              {["Toronto", "Scarborough", "Mississauga", "Brampton", "Markham", "Vaughan"].map((s) => (
                <li key={s}>
                  <span className="text-stone-500 text-xs hover:text-stone-800 transition-colors cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>{s}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-stone-400 text-xs uppercase tracking-[0.2em] font-semibold mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Contact</p>
            <ul className="space-y-4">
              <li>
                <a href="tel:4167241172" className="text-stone-500 text-xs hover:text-stone-800 transition-colors flex items-center gap-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                  <i className="ri-phone-line text-stone-400 text-sm"></i>
                  (416) 724-1172
                </a>
              </li>
              <li>
                <a href="mailto:info@tauruscontracting.ca" className="text-stone-500 text-xs hover:text-stone-800 transition-colors flex items-center gap-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                  <i className="ri-mail-line text-stone-400 text-sm"></i>
                  info@tauruscontracting.ca
                </a>
              </li>
              <li>
                <span className="text-stone-500 text-xs flex items-start gap-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                  <i className="ri-map-pin-line text-stone-400 text-sm mt-0.5 flex-shrink-0"></i>
                  1355 Military Trail,<br />Toronto, ON, M1C 1A3
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-400 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            © Taurus Contracting 2025. All rights reserved.
          </p>
          <p className="text-stone-300 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            General Contracting · Design/Build · Leasehold Improvements · Ontario
          </p>
        </div>
      </div>
    </footer>
  );
}
